import React, { useState, useEffect } from 'react';
import useForm from 'react-hook-form';
import axios from 'axios';
import Alert from '../helpers/Alert';
import { useLocation, useHistory } from 'react-router-dom';
import _ from 'lodash';
/**
 * updates the providers
 * @returns JSX
 */
const UpdateProviders = () => {
  const { register, errors, setValue, getValues, handleSubmit, watch } = useForm();
  const [providerTypesOptions, setProviderTypesOptions] = useState([]);
  const [formValues, setFormValues] = useState({});
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (location.state) {
      const { provider_id, provider_name, username, provider_type_id } = location.state;
      const restoreFileds = { provider_id, provider_name, username, provider_type_id };
      setFormValues({ ...formValues, ...restoreFileds });
      _.mapValues(restoreFileds, (value, key) => {
        setValue(key, value);
      });

      getProviderTypes();
    } else {
      Alert('error', 'Internal Error', 'Could not load update values. Seems you tried to access this page directly.');
      history.push('/providers');
    }
    // eslint-disable-next-line
    }, [])
  /**
   * gets the list of providers types
   */
  const getProviderTypes = async () => {
    try {
      const token = localStorage.getItem('token');
      const { data } = await axios.get('/api/provider/provider-types', { headers: { authorization: token } });
      setProviderTypesOptions(data);
    } catch (err) {
      const { data } = err.response;
      Alert('error', 'Server Error', data);
    }
  };
  /**
   * generic function to handle input
   * @param {string} control
   * @param {any} value
   */
  const handleControl = (control, value) => {
    setValue(control, value);
    setFormValues({ ...formValues, ...getValues() });
  };

  /**
   * handle form submit
   */
  const handleFormSubmit = async () => {
    try {
      const token = localStorage.getItem('token');
      const { provider_id, provider_type_id, provider_name, username, password } = formValues;
      console.log('TCL: handleFormSubmit -> formValues', formValues);
      await axios.put(
        '/api/provider/update-provider',
        { provider_id, provider_type_id, provider_name, username, password },
        { headers: { authorization: token } }
      );
      Alert('success', 'Provider Created', 'Provider created successfully');
    } catch (err) {
      const { data } = err.response;
      Alert('error', 'Server Error', data);
    }
  };

  return (
    <>
      <div className='container-fluid'>
        <div className='row'>
          <div className='card'>
            <div className='card-body'>
              <h4 className='card-title'>Update Providers</h4>
              <form onSubmit={handleSubmit(handleFormSubmit)}>
                <div className='form-group'>
                  <div className='col-md-9'>
                    <label className='mr-3'>Provider Type</label>
                    <select
                      name='provider_type_id'
                      value={formValues['provider_type_id'] || ''}
                      className='form-control  form-control-lg'
                      onChange={(e) => handleControl('provider_type_id', e.target.value)}
                      ref={register({ name: 'provider_type_id' }, { required: { value: true, message: 'Field is required.' } })}
                    >
                      <option value=''>Select Type</option>
                      {providerTypesOptions.map(({ provider_type_id, provider_name }, idx) => {
                        return (
                          <option key={idx} value={provider_type_id}>
                            {provider_name}
                          </option>
                        );
                      })}
                    </select>
                    <p className='error-text'>{errors.provider_type_id && errors.provider_type_id.message}</p>
                  </div>
                </div>
                <div className='form-group'>
                  <div className='col-md-9'>
                    <label className='mr-3'>Provider Name</label>
                    <input
                      name='provider_name'
                      value={formValues['provider_name'] || ''}
                      className='form-control  form-control-lg'
                      onChange={(e) => handleControl('provider_name', e.target.value)}
                      ref={register({ name: 'provider_name' }, { required: { value: true, message: 'Field is required.' } })}
                    ></input>
                    <p className='error-text'>{errors.provider_name && errors.provider_name.message}</p>
                  </div>
                </div>
                <div className='form-group'>
                  <div className='col-md-9'>
                    <label className='mr-3'>Username</label>
                    <input
                      name='username'
                      value={formValues['username'] || ''}
                      className='form-control  form-control-lg'
                      onChange={(e) => handleControl('username', e.target.value)}
                      ref={register({ name: 'username' }, { required: { value: true, message: 'Field is required.' } })}
                    ></input>
                    <p className='error-text'>{errors.username && errors.username.message}</p>
                  </div>
                </div>
                <div className='form-group'>
                  <div className='col-md-9'>
                    <label className='mr-3'>New Password</label>
                    <input
                      name='password'
                      type='password'
                      autoComplete='new-password'
                      value={formValues['password'] || ''}
                      className='form-control  form-control-lg'
                      onChange={(e) => handleControl('password', e.target.value)}
                      ref={register({ name: 'password' }, { required: { value: true, message: 'Field is required.' } })}
                    ></input>
                    <p className='error-text'>{errors.password && errors.password.message}</p>
                  </div>
                </div>
                <div className='form-group'>
                  <div className='col-md-9'>
                    <label className='mr-3'>Confirm Password</label>
                    <input
                      name='repassword'
                      type='password'
                      autoComplete='new-password'
                      value={formValues['repassword'] || ''}
                      className='form-control  form-control-lg'
                      onChange={(e) => handleControl('repassword', e.target.value)}
                      ref={register(
                        { name: 'repassword' },
                        {
                          required: { value: true, message: 'Field is required.' },
                          validate: {
                            value: (value) => {
                              return value === watch('password') ? true : 'Password not matched.';
                            }
                          }
                        }
                      )}
                    ></input>
                    <p className='error-text'>{errors.repassword && errors.repassword.message}</p>
                  </div>
                </div>
                <button type='submit' className='btn btn-primary float-right'>
                  Update
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateProviders;
